export default (name: string) => {
  // prefix name with data_ to avoid properties starting with a number
  return `data_${
    name
      // replace spaces
      .replace(' ', '_')
      // replace periods
      .replace('.', '_')
  }`
}